<template>
  <div>
    <v-btn color="green" class="" icon x-large @click="dialog = true"
      ><v-icon>mdi-plus-box</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="650">
      <v-card>
        <ModalHeader
          title="Edit Item"
          icon="mdi-pencil"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <item-photo-manager
            :photos="item.item_photos"
            :item-id="item.id"
            @photo-added="onPhotoAdded"
            @photo-removed="onPhotoRemoved"
          />
          <v-form ref="form" class="mt-4">
            <v-select
              outlined
              dense
              label="Account Title"
              :items="chart_of_accounts"
              item-text="account_title"
              item-value="id"
              v-model="item.chart_of_account_id"
            ></v-select>
            <v-text-field
              outlined
              dense
              label="Item Name"
              v-model="item.item_name"
            ></v-text-field>
            <v-autocomplete
              outlined
              dense
              label="Item Type"
              v-model="item.item_type_id"
              :items="item_types"
              item-text="item_type"
              item-value="id"
              prepend-icon="mdi-shape"
            ></v-autocomplete>
            <v-autocomplete
              outlined
              dense
              label="Sub-Type"
              v-model="item.item_sub_type_id"
              :items="filtered_sub_types"
              item-text="item_sub_type"
              item-value="id"
              clearable
              :disabled="!item.item_type_id"
              prepend-icon="mdi-shape-outline"
              no-data-text="No sub-types for this type"
            ></v-autocomplete>
            <v-select
              outlined
              dense
              label="Part Classification"
              v-model="item.part_classification"
              :items="partClassificationOptions"
              clearable
              prepend-icon="mdi-tag-outline"
            ></v-select>
            <!-- Unit Price, Profitable Margin, Shipping Cost and Tax Option (VAT)
                 are managed per stock batch (Restock / Edit Stock Batch), not on the
                 item, so they are not editable here. -->
            <v-text-field
              outlined
              dense
              prepend-icon="mdi-cash-multiple"
              type="number"
              label="Selling Price"
              v-model="item.selling_price"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              prepend-icon="mdi-package-variant-closed-plus"
              type="number"
              label="Quantity (read-only)"
              v-model="item.quantity"
              readonly
              disabled
              hint="Stock is managed by FIFO lots. Use Restock / Add Stock to change quantity."
              persistent-hint
            ></v-text-field>
            <v-text-field
              outlined
              dense
              prepend-icon="mdi-alert-circle-outline"
              type="number"
              label="Reorder Point"
              v-model="item.reorder_point"
              hint="Alert when stock falls below this level"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              prepend-icon="mdi-package-variant-closed-minus"
              type="number"
              label="Min Stock Level"
              v-model="item.min_stock_level"
              hint="Minimum stock to maintain"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              prepend-icon="mdi-package"
              type=""
              label="Unit"
              v-model="item.unit"
            ></v-text-field>
            <v-autocomplete
              outlined
              dense
              prepend-icon="mdi-truck"
              label="Supplier"
              v-model="item.supplier"
              :items="suppliers"
              item-text="supplier_name"
              item-value="supplier_name"
            ></v-autocomplete>
            <div class="d-flex">
              <v-text-field
                outlined
                dense
                label="Warranty Count"
                type="number"
                class="mr-5"
                v-model="item.warranty.warranty_count"
              ></v-text-field>
              <v-select
                outlined
                dense
                v-model="item.warranty.warranty_duration"
                label="Warranty Duration"
                :items="['Day/s', 'Week/s', 'Months/s', 'Year']"
              ></v-select>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit_item" :loading="loading">Edit</v-btn>
          <v-btn @click="$emit('close')">Close</v-btn>

          <v-spacer></v-spacer>
          <p class="caption grey--text">addItemModal.vue</p>
        </v-card-actions>
      </v-card></v-dialog
    >
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ItemPhotoManager from "./ItemPhotoManager.vue";
export default {
  components: { ItemPhotoManager },
  props: ["item"],
  data() {
    return {
      show_other: false,
      loading: false,
      ready: false,
      dialog: true,
      partClassificationOptions: [
        { text: "Unclassified", value: null },
        { text: "Major Part", value: "major" },
        { text: "Minor Part", value: "minor" },
      ],
      form: {
        item_name: "",
        item_type: "",
        unit_price: "",
        selling_price: "",
        date_received: "",
        supplier: "",
        warranty_count: "",
        initial_import: "",
        warranty_duration: "",
        profitable_margin: "",
        shipping_cost: "",
        vat: 0,
        is_vat: false,
        unit: "PCS",
      },
    };
  },
  methods: {
    onPhotoAdded(photoData) {
      if (!this.item.item_photos) {
        this.$set(this.item, "item_photos", []);
      }
      this.item.item_photos.push(photoData);
    },
    onPhotoRemoved({ index }) {
      this.item.item_photos.splice(index, 1);
    },

    ...mapActions({
      get_items: "item/get_items",
      get_import_batches: "importBatch/get_import_batches",
      edit_item: "item/edit_item",
      get_chart_of_accounts: "chart_of_account/get_chart_of_accounts",
      get_item_types: "item_type/get_item_types",
      get_item_sub_types: "item_sub_type/get_item_sub_types",
      get_suppliers: "supplier/get_suppliers",
    }),
    async submit_item() {
      this.loading = true;
      try {
        await this.edit_item(this.item);
        this.$alert({
          title: "Success",
          message: "Successfully edited an item",
          color: "success",
          icon: "mdi-check-circle",
        });
      } catch (err) {
        this.$alert({
          title: "Error",
          message:
            "Error: " + (err.response?.data?.error || err.message || err),
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      import_batches: "importBatch/import_batches",
      chart_of_accounts: "chart_of_account/chart_of_accounts",
      item_order_for_add: "item/item_order_for_add",
      item_types: "item_type/item_types",
      item_sub_types: "item_sub_type/item_sub_types",
      suppliers: "supplier/suppliers",
    }),
    filtered_sub_types() {
      if (!this.item || !this.item.item_type_id) return [];
      return this.item_sub_types.filter(
        (st) => st.item_type_id == this.item.item_type_id
      );
    },
  },
  watch: {
    "item.item_type_id"(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.item.item_sub_type_id = null;
      }
    },
  },
  async created() {
    await this.get_items();
    await this.get_import_batches();
    await this.get_chart_of_accounts();
    await this.get_item_types();
    await this.get_item_sub_types();
    await this.get_suppliers();
    this.ready = true;
  },
};
</script>

<style lang="scss" scoped></style>
